export default __webpack_public_path__ + "static/spiritual-maya-activity-2-bafcb1bcb999262df8e7fa00574f7594.jpg";